/**
 * @generated SignedSource<<5294c8cc2c0bcf7c83f1bb935a068542>>
 * @relayHash 5f25e62ab63bb9add0fea460f7a6b1cf
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5f25e62ab63bb9add0fea460f7a6b1cf

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Ch_createOrReuseEpisodeOfCareInput = {
  diagnosisCode: string;
  patientId: string;
  relatedConditions: ReadonlyArray<string>;
};
export type chCreateOrReuseEpisodeOfCareMutation$variables = {
  addConnections: ReadonlyArray<string>;
  input: Ch_createOrReuseEpisodeOfCareInput;
};
export type chCreateOrReuseEpisodeOfCareMutation$data = {
  readonly createOrReuseEpisodeOfCare: {
    readonly episodeOfCare: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"chEpisodeOfCareFragment">;
    } | null;
  };
};
export type chCreateOrReuseEpisodeOfCareMutation = {
  response: chCreateOrReuseEpisodeOfCareMutation$data;
  variables: chCreateOrReuseEpisodeOfCareMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addConnections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "diagnosisCode",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "IcdDiagnosis",
  "kind": "LinkedField",
  "name": "icdDiagnosis",
  "plural": false,
  "selections": [
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAssociation",
      "storageKey": null
    },
    (v4/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secondaryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "associationType",
      "storageKey": null
    },
    (v5/*:: as any*/)
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdBy",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progressNoteId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "service",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reason",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedAt",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attachmentType",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uploadStatus",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryCode",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "conditions",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allergies",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "packageSize",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pharmaCode",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productUrl",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "partnerType",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v34 = [
  (v3/*:: as any*/),
  (v32/*:: as any*/),
  (v33/*:: as any*/)
],
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedBy",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "specialtyId",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "from",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "to",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anamnesis",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileId",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedBy",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedAt",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentAt",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentBy",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "concludedAt",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "concludedBy",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "DocumentFileMetadata",
  "kind": "LinkedField",
  "name": "fileMetadata",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "extension",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lengthInKilobytes",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "additionalInformation",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "employer",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "healthcareProviderId",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "treatmentUnit",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "medicationIds",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "morningDosage",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noonDosage",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eveningDosage",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nightDosage",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recommendedTreatment",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "chCreateOrReuseEpisodeOfCareMutation",
    "selections": [
      {
        "alias": "createOrReuseEpisodeOfCare",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_createOrReuseEpisodeOfCarePayload",
        "kind": "LinkedField",
        "name": "ch_createOrReuseEpisodeOfCare",
        "plural": false,
        "selections": [
          {
            "alias": "episodeOfCare",
            "args": null,
            "concreteType": "ch_EpisodeOfCare",
            "kind": "LinkedField",
            "name": "ch_EpisodeOfCare",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "chEpisodeOfCareFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "chCreateOrReuseEpisodeOfCareMutation",
    "selections": [
      {
        "alias": "createOrReuseEpisodeOfCare",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_createOrReuseEpisodeOfCarePayload",
        "kind": "LinkedField",
        "name": "ch_createOrReuseEpisodeOfCare",
        "plural": false,
        "selections": [
          {
            "alias": "episodeOfCare",
            "args": null,
            "concreteType": "ch_EpisodeOfCare",
            "kind": "LinkedField",
            "name": "ch_EpisodeOfCare",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isVirtual",
                "storageKey": null
              },
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isUpdatable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_ProgressNoteConnection",
                "kind": "LinkedField",
                "name": "progressNotes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ch_ProgressNoteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ch_ProgressNote",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v11/*:: as any*/),
                          (v3/*:: as any*/),
                          (v12/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "episodeOfCareId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "kind",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Appointment",
                            "kind": "LinkedField",
                            "name": "appointment",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "access",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "appointmentType",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "conclusionStatus",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "asyncRequestStatus",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "specialty",
                                "storageKey": null
                              },
                              (v13/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "patientPhoneNumber",
                                "storageKey": null
                              },
                              (v9/*:: as any*/),
                              (v14/*:: as any*/),
                              (v15/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isCompleted",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isInvoiced",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isPartnerInVideoCall",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "questionnaireId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "QuestionnaireCriticalitySummaryOutput",
                                "kind": "LinkedField",
                                "name": "questionnaireCriticalitySummary",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "useCaseName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "criticals",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "warnings",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "infos",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "questionnaireType",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "channel",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "callerRole",
                                "storageKey": null
                              },
                              (v16/*:: as any*/),
                              (v17/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasChatTranscript",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "canUseDoc2U",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ch_TelephoneLine",
                                "kind": "LinkedField",
                                "name": "telephoneLine",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ch_TelephoneLineTranslation",
                                    "kind": "LinkedField",
                                    "name": "telephoneLineTranslations",
                                    "plural": true,
                                    "selections": [
                                      (v16/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "content",
                                        "storageKey": null
                                      },
                                      (v3/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v3/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AppointmentAttachment",
                                "kind": "LinkedField",
                                "name": "appointmentAttachments",
                                "plural": true,
                                "selections": [
                                  (v3/*:: as any*/),
                                  (v18/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "thumbnailUrl",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "uploadDate",
                                    "storageKey": null
                                  },
                                  (v19/*:: as any*/),
                                  (v20/*:: as any*/),
                                  (v21/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "uploadSource",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Address",
                                "kind": "LinkedField",
                                "name": "patientAddress",
                                "plural": false,
                                "selections": [
                                  (v22/*:: as any*/),
                                  (v23/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "houseNumberStreet",
                                    "storageKey": null
                                  },
                                  (v24/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BillingAttribute",
                                "kind": "LinkedField",
                                "name": "billingAttribute",
                                "plural": false,
                                "selections": [
                                  (v3/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isNotBillable",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "notBillableReason",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "treatmentReason",
                                    "storageKey": null
                                  },
                                  (v14/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isVisualSymptomExamination",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "currentGestationWeek",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "organisationId",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "dateOfAccident",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "accidentReference",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isEmployer",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "lawType",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "ivgCaseReference",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mvgCaseReference",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "HealthOverview",
                                "kind": "LinkedField",
                                "name": "healthOverview",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "VitalSign",
                                    "kind": "LinkedField",
                                    "name": "vitalSign",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "bloodPressureDiastolic",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "bloodPressureSystolic",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "bloodSugarMgDl",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "bloodSugarMmol",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "bodyTemperature",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "breathRate",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "cReactiveProtein",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "glasgowComaScaleEye",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "glasgowComaScaleMotor",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "glasgowComaScaleVerbal",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "heartRate",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "oxygenSaturation",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "strepATestPositive",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "visualAnalogPainScale",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GeneralHealthInformation",
                                    "kind": "LinkedField",
                                    "name": "generalHealthInformation",
                                    "plural": false,
                                    "selections": [
                                      (v25/*:: as any*/),
                                      (v26/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "medication",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RequestedMedication",
                                "kind": "LinkedField",
                                "name": "requestedMedications",
                                "plural": true,
                                "selections": [
                                  (v27/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mainSubstance",
                                    "storageKey": null
                                  },
                                  (v28/*:: as any*/),
                                  (v29/*:: as any*/),
                                  (v30/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "requestType",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "IcdDiagnosis",
                                "kind": "LinkedField",
                                "name": "suggestedQuestionnaireDiagnosisCodes",
                                "plural": true,
                                "selections": [
                                  (v4/*:: as any*/),
                                  (v3/*:: as any*/),
                                  (v5/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "partnerUserEmail",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "medgateConnectChannel",
                                "storageKey": null
                              },
                              (v31/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Appointment",
                            "kind": "LinkedField",
                            "name": "followUpAppointment",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "date",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "slotId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "assignedTo",
                                "storageKey": null
                              },
                              (v13/*:: as any*/),
                              (v15/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "initialBookedDateTime",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MedgateEmployee",
                                "kind": "LinkedField",
                                "name": "initialAssignedToUser",
                                "plural": false,
                                "selections": (v34/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rescheduledBy",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rescheduledAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MedgateEmployee",
                                "kind": "LinkedField",
                                "name": "rescheduledByUser",
                                "plural": false,
                                "selections": (v34/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "takenBy",
                                "storageKey": null
                              },
                              (v17/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FileUploadRequest",
                                "kind": "LinkedField",
                                "name": "fileUploadRequest",
                                "plural": false,
                                "selections": [
                                  (v15/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sessionCode",
                                    "storageKey": null
                                  },
                                  (v9/*:: as any*/),
                                  (v3/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MedgateConnectOrder",
                                "kind": "LinkedField",
                                "name": "medgateConnectOrder",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "orderCode",
                                    "storageKey": null
                                  },
                                  (v15/*:: as any*/),
                                  (v9/*:: as any*/),
                                  (v3/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v31/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v8/*:: as any*/),
                          (v35/*:: as any*/),
                          (v10/*:: as any*/),
                          (v9/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ch_ProgressNoteBetterDoc",
                            "kind": "LinkedField",
                            "name": "betterDoc",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isUsed",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rejectionReason",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ch_PointOfCare",
                            "kind": "LinkedField",
                            "name": "pointOfCare",
                            "plural": false,
                            "selections": [
                              (v11/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "medical",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actual",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "reasonForChoosingActual",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isDoctorVisitAvoided",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "careProviderId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Purpose",
                                "kind": "LinkedField",
                                "name": "purpose",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "physicalExam",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "laboratory",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "instrumentalExamination",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v36/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Specialty",
                                "kind": "LinkedField",
                                "name": "careProviderSpecialty",
                                "plural": false,
                                "selections": [
                                  (v3/*:: as any*/),
                                  (v27/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SpecialtyTranslation",
                                    "kind": "LinkedField",
                                    "name": "specialtyTranslations",
                                    "plural": true,
                                    "selections": [
                                      (v3/*:: as any*/),
                                      (v16/*:: as any*/),
                                      (v27/*:: as any*/),
                                      (v36/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PointOfCareSpecialty",
                                "kind": "LinkedField",
                                "name": "pointOfCareSpecialty",
                                "plural": false,
                                "selections": [
                                  (v3/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "word",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "synonym",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PointOfCareSpecialtyTranslation",
                                    "kind": "LinkedField",
                                    "name": "specialtyTranslations",
                                    "plural": true,
                                    "selections": [
                                      (v16/*:: as any*/),
                                      (v27/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Specialty",
                                    "kind": "LinkedField",
                                    "name": "careProviderSpecialty",
                                    "plural": false,
                                    "selections": [
                                      (v3/*:: as any*/),
                                      (v27/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "timeToTreatType",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CareProvider",
                                "kind": "LinkedField",
                                "name": "careProvider",
                                "plural": false,
                                "selections": [
                                  (v3/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "businessName",
                                    "storageKey": null
                                  },
                                  (v37/*:: as any*/),
                                  (v32/*:: as any*/),
                                  (v33/*:: as any*/),
                                  (v38/*:: as any*/),
                                  (v23/*:: as any*/),
                                  (v22/*:: as any*/),
                                  (v24/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "streetAddress",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TreatmentPlan",
                            "kind": "LinkedField",
                            "name": "treatmentPlan",
                            "plural": false,
                            "selections": [
                              (v37/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "followUpInstructions",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "recommended",
                                "storageKey": null
                              },
                              (v39/*:: as any*/),
                              (v40/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v41/*:: as any*/),
                          {
                            "alias": "sickLeave",
                            "args": null,
                            "concreteType": "ch_SickLeave",
                            "kind": "LinkedField",
                            "name": "ch_sickLeave",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v42/*:: as any*/),
                              (v12/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "employerName",
                                "storageKey": null
                              },
                              (v43/*:: as any*/),
                              (v44/*:: as any*/),
                              (v10/*:: as any*/),
                              (v9/*:: as any*/),
                              (v35/*:: as any*/),
                              (v8/*:: as any*/),
                              (v39/*:: as any*/),
                              (v40/*:: as any*/),
                              (v45/*:: as any*/),
                              (v46/*:: as any*/),
                              (v47/*:: as any*/),
                              (v48/*:: as any*/),
                              (v49/*:: as any*/),
                              (v16/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "certificateType",
                                "storageKey": null
                              },
                              (v14/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "workCapacity",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "workCapacityType",
                                "storageKey": null
                              },
                              (v50/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "followUpId",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "generalAttestation",
                            "args": null,
                            "concreteType": "ch_GeneralAttestation",
                            "kind": "LinkedField",
                            "name": "ch_generalAttestation",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v42/*:: as any*/),
                              (v12/*:: as any*/),
                              (v44/*:: as any*/),
                              (v43/*:: as any*/),
                              (v10/*:: as any*/),
                              (v9/*:: as any*/),
                              (v35/*:: as any*/),
                              (v8/*:: as any*/),
                              (v27/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "subject",
                                "storageKey": null
                              },
                              (v45/*:: as any*/),
                              (v46/*:: as any*/),
                              (v47/*:: as any*/),
                              (v48/*:: as any*/),
                              (v49/*:: as any*/),
                              (v16/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "message",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "attestationGuardian",
                            "args": null,
                            "concreteType": "ch_AttestationGuardian",
                            "kind": "LinkedField",
                            "name": "ch_attestationGuardian",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v42/*:: as any*/),
                              (v12/*:: as any*/),
                              (v43/*:: as any*/),
                              (v44/*:: as any*/),
                              (v10/*:: as any*/),
                              (v9/*:: as any*/),
                              (v35/*:: as any*/),
                              (v8/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "durationFrom",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "durationTo",
                                "storageKey": null
                              },
                              (v45/*:: as any*/),
                              (v46/*:: as any*/),
                              (v47/*:: as any*/),
                              (v48/*:: as any*/),
                              (v49/*:: as any*/),
                              (v16/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "certificate",
                                "storageKey": null
                              },
                              (v32/*:: as any*/),
                              (v33/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "birthDate",
                                "storageKey": null
                              },
                              (v51/*:: as any*/),
                              (v50/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "psychologicalPsychotherapy",
                            "args": null,
                            "concreteType": "ch_PsychotherapyPrescription",
                            "kind": "LinkedField",
                            "name": "ch_psychotherapyPrescription",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v42/*:: as any*/),
                              (v12/*:: as any*/),
                              (v52/*:: as any*/),
                              (v4/*:: as any*/),
                              (v43/*:: as any*/),
                              (v44/*:: as any*/),
                              (v10/*:: as any*/),
                              (v9/*:: as any*/),
                              (v35/*:: as any*/),
                              (v8/*:: as any*/),
                              (v45/*:: as any*/),
                              (v46/*:: as any*/),
                              (v47/*:: as any*/),
                              (v48/*:: as any*/),
                              (v49/*:: as any*/),
                              (v7/*:: as any*/),
                              (v50/*:: as any*/),
                              (v16/*:: as any*/),
                              (v14/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "therapyPrescription",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "physiotherapy",
                            "args": null,
                            "concreteType": "ch_PhysiotherapyPrescription",
                            "kind": "LinkedField",
                            "name": "ch_physiotherapyPrescription",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v42/*:: as any*/),
                              (v12/*:: as any*/),
                              (v52/*:: as any*/),
                              (v4/*:: as any*/),
                              (v25/*:: as any*/),
                              (v26/*:: as any*/),
                              (v53/*:: as any*/),
                              (v43/*:: as any*/),
                              (v44/*:: as any*/),
                              (v10/*:: as any*/),
                              (v9/*:: as any*/),
                              (v35/*:: as any*/),
                              (v8/*:: as any*/),
                              (v45/*:: as any*/),
                              (v46/*:: as any*/),
                              (v47/*:: as any*/),
                              (v48/*:: as any*/),
                              (v49/*:: as any*/),
                              (v7/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "aims",
                                "storageKey": null
                              },
                              (v54/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "conditionStage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "duration",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "internalNote",
                                "storageKey": null
                              },
                              (v16/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "leadingSymptom",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "prescriptionRepetition",
                                "storageKey": null
                              },
                              (v14/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sides",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "trigger",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "treatmentUnitPerDay",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isHomeTreatment",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "occurrence",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ch_NutritionalPrescription",
                            "kind": "LinkedField",
                            "name": "ch_nutritionalPrescription",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v12/*:: as any*/),
                              (v52/*:: as any*/),
                              (v4/*:: as any*/),
                              (v54/*:: as any*/),
                              (v16/*:: as any*/),
                              (v42/*:: as any*/),
                              (v43/*:: as any*/),
                              (v44/*:: as any*/),
                              (v10/*:: as any*/),
                              (v9/*:: as any*/),
                              (v35/*:: as any*/),
                              (v8/*:: as any*/),
                              (v45/*:: as any*/),
                              (v46/*:: as any*/),
                              (v47/*:: as any*/),
                              (v48/*:: as any*/),
                              (v49/*:: as any*/),
                              (v50/*:: as any*/),
                              (v14/*:: as any*/),
                              (v26/*:: as any*/),
                              (v25/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "nutritionalConditions",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "obesityTherapy",
                                "storageKey": null
                              },
                              (v53/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "prescription",
                            "args": null,
                            "concreteType": "ch_Prescription",
                            "kind": "LinkedField",
                            "name": "ch_prescription",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v42/*:: as any*/),
                              (v12/*:: as any*/),
                              (v52/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ch_Medication",
                                "kind": "LinkedField",
                                "name": "medications",
                                "plural": true,
                                "selections": [
                                  (v3/*:: as any*/),
                                  (v27/*:: as any*/),
                                  (v55/*:: as any*/),
                                  (v56/*:: as any*/),
                                  (v57/*:: as any*/),
                                  (v58/*:: as any*/),
                                  (v59/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v43/*:: as any*/),
                              (v44/*:: as any*/),
                              (v10/*:: as any*/),
                              (v9/*:: as any*/),
                              (v35/*:: as any*/),
                              (v8/*:: as any*/),
                              (v45/*:: as any*/),
                              (v46/*:: as any*/),
                              (v47/*:: as any*/),
                              (v48/*:: as any*/),
                              (v49/*:: as any*/),
                              (v16/*:: as any*/),
                              (v7/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "measLaboratoryPrescription",
                            "args": null,
                            "concreteType": "ch_MeasLaboratoryPrescription",
                            "kind": "LinkedField",
                            "name": "ch_measLaboratoryPrescription",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v42/*:: as any*/),
                              (v12/*:: as any*/),
                              (v43/*:: as any*/),
                              (v44/*:: as any*/),
                              (v10/*:: as any*/),
                              (v9/*:: as any*/),
                              (v35/*:: as any*/),
                              (v8/*:: as any*/),
                              (v45/*:: as any*/),
                              (v46/*:: as any*/),
                              (v47/*:: as any*/),
                              (v48/*:: as any*/),
                              (v49/*:: as any*/),
                              (v16/*:: as any*/),
                              (v7/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "bloodChemistries",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "coagulations",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hematologies",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "urineDiagnostics",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rapidTests",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "referralLetter",
                            "args": null,
                            "concreteType": "ch_ReferralLetter",
                            "kind": "LinkedField",
                            "name": "ch_referralLetter",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v42/*:: as any*/),
                              (v12/*:: as any*/),
                              (v43/*:: as any*/),
                              (v44/*:: as any*/),
                              (v10/*:: as any*/),
                              (v9/*:: as any*/),
                              (v35/*:: as any*/),
                              (v8/*:: as any*/),
                              (v47/*:: as any*/),
                              (v48/*:: as any*/),
                              (v49/*:: as any*/),
                              (v7/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "reasoning",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "referralId",
                                "storageKey": null
                              },
                              (v54/*:: as any*/),
                              (v25/*:: as any*/),
                              (v26/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "documentLanguage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "careProviderIds",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CareProvider",
                                "kind": "LinkedField",
                                "name": "careProvidersCopyTo",
                                "plural": true,
                                "selections": [
                                  (v3/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v6/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ch_ConsultationReport",
                            "kind": "LinkedField",
                            "name": "ch_consultationReport",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v42/*:: as any*/),
                              (v12/*:: as any*/),
                              (v43/*:: as any*/),
                              (v44/*:: as any*/),
                              (v10/*:: as any*/),
                              (v9/*:: as any*/),
                              (v35/*:: as any*/),
                              (v8/*:: as any*/),
                              (v47/*:: as any*/),
                              (v48/*:: as any*/),
                              (v45/*:: as any*/),
                              (v46/*:: as any*/),
                              (v16/*:: as any*/),
                              (v52/*:: as any*/),
                              (v4/*:: as any*/),
                              (v41/*:: as any*/),
                              (v60/*:: as any*/),
                              (v49/*:: as any*/),
                              (v7/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isAiGenerated",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isAiContentModified",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "carePlanSummary",
                            "args": null,
                            "concreteType": "Ch_carePlanSummaryConnection",
                            "kind": "LinkedField",
                            "name": "ch_carePlanSummary",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Ch_carePlanSummaryEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CarePlanSummary",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CarePlanTreatmentPlan",
                                        "kind": "LinkedField",
                                        "name": "treatmentPlan",
                                        "plural": false,
                                        "selections": [
                                          (v37/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "followUpTreatment",
                                            "storageKey": null
                                          },
                                          (v60/*:: as any*/),
                                          (v39/*:: as any*/),
                                          (v40/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v42/*:: as any*/),
                                      (v12/*:: as any*/),
                                      (v43/*:: as any*/),
                                      (v44/*:: as any*/),
                                      (v10/*:: as any*/),
                                      (v9/*:: as any*/),
                                      (v35/*:: as any*/),
                                      (v8/*:: as any*/),
                                      (v47/*:: as any*/),
                                      (v48/*:: as any*/),
                                      (v49/*:: as any*/),
                                      (v11/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v61/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v62/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "carePlanSummary",
                            "args": null,
                            "filters": null,
                            "handle": "connection",
                            "key": "ProgressNoteConnection_carePlanSummary",
                            "kind": "LinkedHandle",
                            "name": "ch_carePlanSummary"
                          },
                          {
                            "alias": "timeWindows",
                            "args": null,
                            "concreteType": "Ch_timeWindowsConnection",
                            "kind": "LinkedField",
                            "name": "ch_timeWindows",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Ch_timeWindowsEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ch_TimeWindow",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*:: as any*/),
                                      (v11/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v61/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v62/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "timeWindows",
                            "args": null,
                            "filters": null,
                            "handle": "connection",
                            "key": "ChProgressNoteConnection_ch_timeWindows",
                            "kind": "LinkedHandle",
                            "name": "ch_timeWindows"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ch_MeasRadiologyPrescription",
                            "kind": "LinkedField",
                            "name": "ch_measRadiologyPrescription",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v42/*:: as any*/),
                              (v12/*:: as any*/),
                              (v43/*:: as any*/),
                              (v44/*:: as any*/),
                              (v10/*:: as any*/),
                              (v9/*:: as any*/),
                              (v35/*:: as any*/),
                              (v8/*:: as any*/),
                              (v47/*:: as any*/),
                              (v48/*:: as any*/),
                              (v45/*:: as any*/),
                              (v46/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "requestExaminations",
                                "storageKey": null
                              },
                              (v49/*:: as any*/),
                              (v7/*:: as any*/),
                              (v16/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "clinicalAssessment",
                                "storageKey": null
                              },
                              (v51/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "pregnantStatus",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "question",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ch_NeuropsychologicDiagnosticPrescription",
                            "kind": "LinkedField",
                            "name": "ch_neuropsychologicDiagnosticPrescription",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v7/*:: as any*/),
                              (v12/*:: as any*/),
                              (v9/*:: as any*/),
                              (v8/*:: as any*/),
                              (v44/*:: as any*/),
                              (v43/*:: as any*/),
                              (v16/*:: as any*/),
                              (v10/*:: as any*/),
                              (v35/*:: as any*/),
                              (v45/*:: as any*/),
                              (v46/*:: as any*/),
                              (v47/*:: as any*/),
                              (v48/*:: as any*/),
                              (v42/*:: as any*/),
                              (v49/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "medicalPrescriptions",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "relationship",
                                "storageKey": null
                              },
                              (v27/*:: as any*/),
                              (v38/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "email",
                                "storageKey": null
                              },
                              (v52/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ch_LaboratoryPrescription",
                            "kind": "LinkedField",
                            "name": "ch_laboratoryPrescription",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v7/*:: as any*/),
                              (v12/*:: as any*/),
                              (v9/*:: as any*/),
                              (v8/*:: as any*/),
                              (v44/*:: as any*/),
                              (v43/*:: as any*/),
                              (v16/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "externalExaminations",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "pointOfCareExaminations",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isDoc2u",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "additionalRemark",
                                "storageKey": null
                              },
                              (v10/*:: as any*/),
                              (v35/*:: as any*/),
                              (v45/*:: as any*/),
                              (v46/*:: as any*/),
                              (v47/*:: as any*/),
                              (v48/*:: as any*/),
                              (v42/*:: as any*/),
                              (v49/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MedicalReportAttachmentConnection",
                            "kind": "LinkedField",
                            "name": "medicalReportAttachments",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MedicalReportAttachmentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MedicalReportAttachment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*:: as any*/),
                                      (v18/*:: as any*/),
                                      (v9/*:: as any*/),
                                      (v19/*:: as any*/),
                                      (v20/*:: as any*/),
                                      (v21/*:: as any*/),
                                      (v12/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "reportType",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "sessionId",
                                        "storageKey": null
                                      },
                                      (v11/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v61/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v62/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "filters": null,
                            "handle": "connection",
                            "key": "ProgressNoteConnection_medicalReportAttachments",
                            "kind": "LinkedHandle",
                            "name": "medicalReportAttachments"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Ch_recommendedMedicationsConnection",
                            "kind": "LinkedField",
                            "name": "ch_recommendedMedications",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Ch_recommendedMedicationsEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ch_RecommendedMedication",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v12/*:: as any*/),
                                      (v7/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "medicationId",
                                        "storageKey": null
                                      },
                                      (v3/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ch_Medication",
                                        "kind": "LinkedField",
                                        "name": "medication",
                                        "plural": false,
                                        "selections": [
                                          (v11/*:: as any*/),
                                          (v3/*:: as any*/),
                                          (v27/*:: as any*/),
                                          (v7/*:: as any*/),
                                          (v29/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "startDate",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "endDate",
                                            "storageKey": null
                                          },
                                          (v59/*:: as any*/),
                                          (v55/*:: as any*/),
                                          (v56/*:: as any*/),
                                          (v57/*:: as any*/),
                                          (v58/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "usageInstructions",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "internalNotes",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "templateId",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "templateCategory",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "type",
                                            "storageKey": null
                                          },
                                          (v30/*:: as any*/),
                                          (v28/*:: as any*/),
                                          (v10/*:: as any*/),
                                          (v35/*:: as any*/),
                                          (v9/*:: as any*/),
                                          (v8/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "refuseSubstitutes",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "numberOfPackages",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isPermanentPrescription",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v11/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v61/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v62/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "filters": null,
                            "handle": "connection",
                            "key": "ProgressNoteConnection_ch_recommendedMedications",
                            "kind": "LinkedHandle",
                            "name": "ch_recommendedMedications"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Ch_callTranscriptsConnection",
                            "kind": "LinkedField",
                            "name": "ch_callTranscripts",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Ch_callTranscriptsEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CallTranscript",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TranscriptEntry",
                                        "kind": "LinkedField",
                                        "name": "transcript",
                                        "plural": true,
                                        "selections": [
                                          (v3/*:: as any*/),
                                          (v5/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "callTranscriptEndedAt",
                                        "storageKey": null
                                      },
                                      (v11/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v61/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v62/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "filters": null,
                            "handle": "connection",
                            "key": "ProgressNoteConnection_ch_callTranscripts",
                            "kind": "LinkedHandle",
                            "name": "ch_callTranscripts"
                          }
                        ],
                        "storageKey": null
                      },
                      (v61/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v62/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "connection",
                "key": "EpisodeOfCareProgressNotesConnection_progressNotes",
                "kind": "LinkedHandle",
                "name": "progressNotes"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RelatedCondition",
                "kind": "LinkedField",
                "name": "relatedConditions",
                "plural": true,
                "selections": [
                  (v3/*:: as any*/),
                  (v6/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "episodeOfCare",
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "ch_EpisodeOfCare",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "addConnections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "ch_EpisodeOfCareEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "5f25e62ab63bb9add0fea460f7a6b1cf",
    "metadata": {},
    "name": "chCreateOrReuseEpisodeOfCareMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ded45feb4840539dcfba884bb0e4083f";

export default node;
